import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiGetPaymentTypeList } from 'src/api/payment';

interface PaymentType {
  value: string;
  label: string;
}

interface PaymentTypeContextType {
  paymentTypes: PaymentType[];
  loading: boolean;
  error: Error | null;
  refreshPaymentTypes: () => Promise<void>;
}

const PaymentTypeContext = createContext<PaymentTypeContextType>({
  paymentTypes: [],
  loading: false,
  error: null,
  refreshPaymentTypes: async () => {},
});

export const PaymentTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [paymentTypes, setPaymentTypes] = useState<PaymentType[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchPaymentTypes = async () => {
    try {
      setLoading(true);
      const response = await apiGetPaymentTypeList();
      if (response?.rsData) {
        setPaymentTypes(response.rsData);
      }
    } catch (err) {
      setError(err instanceof Error ? err : new Error('An error occurred'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(!window.location.href.includes('account/login')) {
    fetchPaymentTypes();
    }
  }, []);

  const refreshPaymentTypes = async () => {
    await fetchPaymentTypes();
  };

  return (
    <PaymentTypeContext.Provider value={{ paymentTypes, loading, error, refreshPaymentTypes }}>
      {children}
    </PaymentTypeContext.Provider>
  );
};

export const usePaymentTypes = () => useContext(PaymentTypeContext);
